import identity from "lodash/fp/identity";

class PaymentMethodsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [{ title: "Payment Method", name: "name" }];

    this.item = {
      title: "Payment Method",
      state: "paymentmethod",
      name: "payment-method",
    };

    this.addOptions = {
      title: "Add New Payment Method",
      icon: "add",
      fields: [
        {
          name: "name",
          title: "Payment Method Name",
          type: "text",
          isText: true,
          isRequired: true,
        },
        {
          name: "referenceName",
          title: "Payment Method Reference Name",
          type: "text",
          isText: true,
          isRequired: true,
        },
        {
          name: "referenceType",
          title: "Payment Method Reference Type",
          list: "paymentMethodsReferencesTypes",
          isRequired: true,
        },
        {
          name: "referenceMinLength",
          title: "Payment Method Reference Minimum Length",
          type: "number",
          min: "1",
          isText: true,
          isRequired: true,
        },
        {
          name: "referenceMaxLength",
          title: "Payment Method Reference Maximum Length",
          type: "number",
          isText: true,
          isRequired: true,
        },
        {
          name: "referenceRequired",
          title: "Payment Method Reference Required",
          isCheckBox: true,
        },
      ],
    };
  }

  justify(data) {
    return identity(data);
  }
}

export default PaymentMethodsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/paymentMethods/paymentMethods.transforms.js